<template>
  <div class="v-input-radio">
    <input
      type="radio"
      class="v-input-radio__input"
      :id="id"
      :name="name"
      :value="value"
      @change="$emit('change', $event.target.value)"
      :checked="isChecked"
    >
    <label
      :class="hasClassPrincipal"
      :for="id"
    >
      {{ label }}
      <div v-if="isPrincipal" class="principal-container">
        <StarSvg class="principal-star"/>
        <span class="principal-text">Contato Principal</span>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'VInputRadio',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    name: { type: String, required: true },
    value: { default: '' },
    isPrincipal: { type: Boolean },
    modelValue: {},
  },
  computed: {
    isChecked() {
      if (this.modelValue) {
        return this.modelValue === this.value;
      }
      return this.isPrincipal;
    },
    hasClassPrincipal() {
      return `v-input-radio__label ${this.isPrincipal ? 'principal' : null}`;
    }
  },
};
</script>

<style lang="scss" scoped>
.v-input-radio {
  position: relative;
  cursor: pointer;
  text-align: left;

  &__input {
    font-weight: 'bold';
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    opacity: 0;

    &:not(:checked) + label:after,
    &:checked + label:after {
      content: '';
      width: 16px;
      height: 24px;
      position: absolute;
      top: 18px;
      left: 20px;
      font-size: 11px;
      line-height: 18px;
      transform: scale(0);
      transition: all 0.2s;
      border-radius: 50%;
      background-color: var(--color-primary);
    }

    &:checked + label {
      border-color: var(--color-primary);
    }

    &:checked + label:after {
      opacity: 1;
      transform: scale(1);
    }

    &:checked + label:before {
      border-color: var(--color-primary);
    }
  }

  &__label {
    position: relative;
    cursor: pointer;
    display: block;
    border: 1px solid var(--color-grey-3);
    border-radius: 4px;
    height: 56px;
    padding: 16px 0 0 16px;
    transition: border 0.3s ease;

    &:before {
      content: '';
      display: inline-block;
      box-sizing: border-box;
      border-radius: 50%;
      vertical-align: top;
      width: 24px;
      height: 24px;
      margin: -2px 10px 0 0;
      border: 1px solid var(--color-grey-6);
      transition: all 0.3s ease;
    }
  }

  .principal {
    font-weight: 700;
    height: 85px;

    &-star {
      background-size: 2px 2px;
      margin-right: 10px;
    }

    &-container {
      background-color: #C8EED3;
      width: fit-content;
      margin: 10px 3px 3px 3px;
      border-radius: 24px;
      padding: 3px 10px;
    }

    &-text {
      font-size: 14px;
    }
  }

}
</style>
